import DialogContentEntry from "./DialogContentEntry";
import DialogInlineEntry from "./DialogInlineEntry";

export default () => [DialogContentEntry(), DialogInlineEntry()];
